import { type ReactNode } from 'react';
import { useTranslation } from 'react-i18next';
import { footerItemType, type FooterV2Response } from '@cx-web/domain-types';

import FooterGeneralLinks from '../footer/components/FooterGeneralLinks';
import FooterMeta from '../footer/components/FooterMeta';

import { getSocialLinks } from './social-links';

export type CxFooterLeanProps = {
  footerData?: FooterV2Response;
  isAdmiralCookieBannerEnabled: boolean;
  logo: ReactNode;
};

export const CxFooterLean = ({ footerData, isAdmiralCookieBannerEnabled, logo }: CxFooterLeanProps) => {
  const { t } = useTranslation(['label']);

  return (
    <>
      <FooterMeta
        legalAge={t('CX_LEGAL_AGE')}
        legalText={t('CX_FOOTER_LEGAL')}
        levelTwo={footerData?.levelTwo ?? []}
        logo={logo}
        logoType={footerItemType.LOGO}
        socialLinks={getSocialLinks(t)}
      />
      <FooterGeneralLinks
        isAdmiralCookieBannerEnabled={isAdmiralCookieBannerEnabled}
        levelThree={footerData?.levelThree ?? []}
      />
    </>
  );
};
